import React from 'react'
import {Input, ParagraphText, Button, Select} from '@thryvlabs/maverick'
import {toast} from 'react-toastify'
import {Controller} from 'react-hook-form'
import {useAsync} from '../utils/use-async'
import {useAuthClient} from '../utils/use-auth-client'
import '../styles/formScreensStyles.css'
import {useSelector} from 'react-redux'

export const AccountDetails = ({
  register,
  errors,
  listOfStates,
  validatedEmail,
  setValidatedEmail,
  email,
  emailRegistered,
  setEmailRegistered,
  setAccountInformation,
  setFormFilledStatus,
  trigger,
  control,
  state,
  handleSubmit,
  stateLabel = 'State',
}) => {
  const {run} = useAsync({
    status: 'pending',
  })
  const client = useAuthClient()
  const {isMobileViewEnable} = useSelector(state => state.screenView)
  console.log({isMobileViewEnable})

  const inputClassName = emailRegistered
    ? 'form-input w-full disabled'
    : 'form-input w-full enabled'

  const preventUnvalidatedEmail = () => {
    if (validatedEmail !== email && !emailRegistered) {
      setEmailRegistered(true)
      setValidatedEmail('')
    }
  }
  const handleEmailValidation = async () => {
    const emailRegex = /^[a-zA-Z0-9._+-]+@[^\s@]+\.[^\s@]+$/
    if (emailRegex.test(email)) {
      const isThryvEmail = email.includes('@thryv.com')
      if (isThryvEmail === false) {
        try {
          console.log('not a thryv acc')
          const response = await run(client(`orders/validate-email/${email}`))
          console.log({response})
          if (response?.orderCanContinue && !response?.thryvId) {
            setValidatedEmail(email)
            setEmailRegistered(false)
            // Disable the Next button when orderCanContinue is true
            //setAccountInformation(prev => ({...prev, email}))
          } else {
            console.log('toast nees to eb triggered')
            toast.error(
              'Oops! Looks like we already have this email address registered. Please reach out to your Partner representative to confirm enrollment/purchase.',
            )
          }
        } catch (err) {
          // if (err.message === 'Recurly account not found') {
          toast.error(
            'Oops! Looks like we already have this email address registered. Please reach out to your Partner representative to confirm enrollment/purchase.',
          )
          // } else {
          //   toast.error(err.message)
          // }
        }
      } else {
        toast.error('Thryv addresses are not allowed')
      }
    } else {
      toast.error('Valid email address required')
    }
  }
  return (
    <>
      <ParagraphText
        variant="reg"
        className={`section-title ${isMobileViewEnable ? 'mobile-view-header' : ''}`}
      >
        Payment Information <span className="required-field">*</span>
      </ParagraphText>
      {/* <div> */}
      <div className="d-flex justify-content-between mt-4 gap-6">
        <div className="w-100">
          <Input
            type="text"
            placeholder="Email Address"
            aria-label="Email Address"
            name="email"
            withLabel
            labelType="floating"
            variant="default"
            register={register}
            errors={errors}
            onChange={preventUnvalidatedEmail()}
            style={{
              opacity: 1,
            }}
            className={`w-full ${inputClassName}`}
          />
        </div>
        <div>
          <Button
            variant="primary"
            type="button"
            name="Validate"
            onClick={handleEmailValidation}
            className="btn-validate"
            disabled={!emailRegistered}
          >
            Next
          </Button>
        </div>
      </div>
      <div
        className={`d-flex ${isMobileViewEnable ? 'flex-column mt-4' : 'justify-content-between mt-4 gap-4'}`}
      >
        <div className="w-full">
          <Input
            type="text"
            placeholder="First Name"
            aria-label="First Name"
            name="firstName"
            withLabel
            labelType="floating"
            variant="default"
            register={register}
            errors={errors}
            disabled={emailRegistered}
            className={inputClassName}
          />
        </div>
        <div className={`w-full ${isMobileViewEnable ? 'mt-4' : ''}`}>
          <Input
            type="text"
            placeholder="Last Name"
            aria-label="Last Name"
            name="lastName"
            withLabel
            labelType="floating"
            variant="default"
            register={register}
            errors={errors}
            disabled={emailRegistered}
            className={inputClassName}
          />
        </div>
      </div>
      <div className="d-flex mt-4 mr-4">
        <div className="w-full">
          <Input
            type="text"
            placeholder="Mobile Number"
            aria-label="Mobile Number"
            name="mobile"
            maxLength={18}
            withLabel
            labelType="floating"
            variant="default"
            register={register}
            errors={errors}
            disabled={emailRegistered}
            className={inputClassName}
          />
        </div>
      </div>
      <div className="mt-4 mb-5">
        <ParagraphText
          variant="reg"
          className={`section-title ${emailRegistered ? 'disabled' : 'enabled'}`}
        >
          Business Address <span className="required-field">*</span>
        </ParagraphText>
        <div className="d-flex justify-content-between mt-4">
          <div className="w-100">
            <Input
              type="text"
              placeholder="Company"
              aria-label="Company"
              name="company"
              withLabel
              labelType="floating"
              variant="default"
              register={register}
              errors={errors}
              disabled={emailRegistered}
              className={`w-100 ${inputClassName}`}
            />
          </div>
        </div>
        <div
          className={`d-flex ${isMobileViewEnable ? 'flex-column' : 'justify-content-between '} gap-4  mt-4`}
        >
          <div className={`${isMobileViewEnable ? 'w-100' : 'w-50'}`}>
            <Input
              type="text"
              placeholder="Business Phone"
              aria-label="Business Phone"
              name="companyPhone"
              maxLength={18}
              withLabel
              labelType="floating"
              variant="default"
              register={register}
              errors={errors}
              disabled={emailRegistered}
              className={`w-100 ${inputClassName}`}
            />
          </div>
          <div className={`${isMobileViewEnable ? 'w-100' : 'w-50'}`}>
            <Input
              type="text"
              placeholder="Website"
              name="websiteName"
              aria-label="Website"
              withLabel
              labelType="floating"
              variant="default"
              register={register}
              errors={errors}
              disabled={emailRegistered}
              className={inputClassName}
            />
          </div>
        </div>
        <div className="d-flex mt-4">
          <div className="w-100">
            <Input
              type="text"
              placeholder="Customer Address"
              aria-label="Customer Address"
              name="address"
              withLabel
              labelType="floating"
              variant="default"
              register={register}
              errors={errors}
              disabled={emailRegistered}
              className={`w-100 ${inputClassName}`}
            />
          </div>
        </div>
        <div
          className={`d-flex ${isMobileViewEnable ? 'flex-column' : ''} mt-4 gap-4`}
        >
          <div className={`${isMobileViewEnable ? 'w-100' : 'w-30'}`}>
            <Input
              type="text"
              placeholder="City"
              aria-label="City"
              name="city"
              withLabel
              labelType="floating"
              variant="default"
              register={register}
              errors={errors}
              disabled={emailRegistered}
              className={`w-100 custom-mt ${inputClassName}`}
            />
          </div>
          <div
            className={`${isMobileViewEnable ? 'w-100' : 'w-30'} ${inputClassName}`}
            style={{
              marginTop: '-7px',
            }}
          >
            <Controller
              control={control}
              name="state"
              render={({field: {onChange, name}}) => (
                <Select
                  options={listOfStates}
                  width="full"
                  selectLabel={`Select ${stateLabel}`}
                  selectedOption={state}
                  onChange={onChange}
                  errors={errors}
                  name={name}
                  hidden
                  className={`select mt-0 ${inputClassName}`}
                />
              )}
            />
          </div>
          <div className={`${isMobileViewEnable ? 'w-100' : 'w-30'}`}>
            <Input
              type="text"
              placeholder="Postal Code"
              aria-label="Postal Code"
              name="postCode"
              withLabel
              labelType="floating"
              variant="default"
              register={register}
              errors={errors}
              disabled={emailRegistered}
              className={`w-100 ${inputClassName}`}
            />
          </div>
        </div>
      </div>
    </>
  )
}
